

export const isValidEmail = (email) => {
    // Expresión regular para validar el formato de correo electrónico
    // - No debe terminar con un carácter especial o con un punto
    // - Puede contener caracteres especiales solo si son + o .
    const emailRegex = /^[^\s@]+@[^@\s]+\.[^@\s]{2,}(?<![\W.])$/;
    const invalidCharsRegex = /[!#$%&'*\/=?^`{|}~]/;

    return emailRegex.test(email) && !invalidCharsRegex.test(email);
};

export function validarCedula(cedula) {
    if (!/^\d{11}$/.test(cedula)) {
        return false;
    }

    let c = cedula.split('').map(Number);
    let v = [1, 2, 1, 2, 1, 2, 1, 2, 1, 2];
    let result = 0;

    for (let i = 0; i < 10; i++) {
        let producto = c[i] * v[i];
        let sumaDigitos = producto >= 10
            ? producto.toString().split('').reduce((sum, num) => sum + parseInt(num), 0)
            : producto;
        result += sumaDigitos;
    }

    let proximoMultiplo = Math.ceil(result / 10) * 10;
    let digitoVerificador = proximoMultiplo - result;

    return c[10] === digitoVerificador ? true : false;
}


export const Limpiar = (value) => {
    if (value === null) {
        return "";
    }

    var result = "";
    var characters = "ABCDEFGHIJKLMNÑOPQRSTUVWXYZ0123456789";

    for (let i = 0; i < value.length; i++) {
        result += characters.includes(value[i]) ? value[i] : "";
    }

    return result;
};